import { defineStore } from 'pinia';

import * as state from './billing.state';
import * as getters from './billing.getters';
import * as actions from './billing.actions';

export const useBillingStore = defineStore('billing', () => ({
  ...state,
  ...getters,
  ...actions
}));
